import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import PayPalButton from "../components/PaypalButton";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import Box from '@mui/material/Box';
import StripeWechatPayButton from './StripeWechatPayButton';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function CheckoutDialog({open, productInfo, onClose, onPaymentSuccess}) {
  // const [open, setOpen] = React.useState(false);

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  // const handleClose = () => {
  //   setOpen(false);
  // };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        slots={{
          transition: Transition,
        }}
        keepMounted
        // onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"订单确认"}</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Card sx={{ maxWidth: 380, borderRadius: 0 }} elevation={0} >
            <CardMedia
              component="img"
              // height="210px"
              image={productInfo.img_url}
              alt="green iguana"
              sx={{
                height: "auto",
                width: "100%"
              }}
            />
            <CardContent sx={{paddingLeft: 0, paddingRight: 0}} >
              <Box sx={{width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between'  // 这会使子元素分别靠左和靠右
                      }}>
                <Typography gutterBottom variant="h6" component="div">
                  {productInfo.title}
                </Typography>
                <Typography gutterBottom variant="h6" component="div" color='#EF6679'>
                  ${productInfo.amount}
                </Typography>
              </Box>
              <Box sx={{width: '100%', minHeight: '30px', borderRadius: '8px', padding: "8px"}}>
                {productInfo.contents.map((content, index) => (
                  <Typography key={index} variant="body2" sx={{ 
                     color: 'text.secondary',
                      marginBottom: '8px', // 设置每行文本的下边距
                      '&:last-child': {
                        marginBottom: 0, // 最后一行不需要下边距
                      }
                    }}>
                    {content}
                  </Typography>
                ))}
              </Box>
            </CardContent>
            <DialogActions sx={{
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
                }}>
              {/* <Button onClick={onClose}>Disagree</Button>
              <Button onClick={onClose}>Agree</Button> */}
              {/* [TODO]: 后续需要做一个点击确认"使用条款和隐私政策"勾选 + "下一步"按钮 */}
              {/* <PayPalButton amount={productInfo.amount} onSuccess={onPaymentSuccess} /> */}
              <StripeWechatPayButton amount={productInfo.amount} productName={productInfo.product_name} productInfo={productInfo}></StripeWechatPayButton>
            </DialogActions>
          </Card>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
